module.exports = __webpack_public_path__ + "static/media/mindaffect.43cf4722.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/mindaffect.webp
// module id = 360
// module chunks = 0